export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';
export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';
export const SET_SPINNER = 'SET_SPINNER';
export const CLEAR_SPINNER = 'CLEAR_SPINNER';
